export enum ePage {
  Main,
  ExcelSummary,
  EntityList,
  EnityValidation,
  PdfFinalProcessing
}
